import { render, staticRenderFns } from "./ExtendDetail.vue?vue&type=template&id=33b3cc26&scoped=true"
import script from "./ExtendDetail.vue?vue&type=script&lang=js"
export * from "./ExtendDetail.vue?vue&type=script&lang=js"
import style0 from "./ExtendDetail.vue?vue&type=style&index=0&id=33b3cc26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b3cc26",
  null
  
)

export default component.exports